function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

function toCssLength(value) {
  return typeof value === "number" ? `${value}px` : value;
}

export default function Skeleton({
  shape = "block",
  width,
  height,
  className = "",
  style,
  ...props
}) {
  const accessibleLabel = props["aria-label"];
  const resolvedHeight = shape === "circle" && height === undefined ? width : height;

  return (
    <span
      {...props}
      className={joinClassNames(
        "lz-v2-skeleton",
        `lz-v2-skeleton--${shape}`,
        className
      )}
      style={{
        ...style,
        width: toCssLength(width),
        height: toCssLength(resolvedHeight),
      }}
      role={accessibleLabel ? "status" : undefined}
      aria-hidden={accessibleLabel ? undefined : "true"}
    />
  );
}
